import { createSlice } from "@reduxjs/toolkit";
import { prepareDependenciesQuestionsWithRepeatedOnes, searchForNodeInTreeAndReplace } from "utils/helpers";

const initialState = {};

export const slice = createSlice({
	name: "procedures",
	initialState,
	reducers: {
		replace: (_state, { payload: { questions = [], statements = [] } }) => ({
			statements,
			questions: [
				...(prepareDependenciesQuestionsWithRepeatedOnes({
					questions: questions,
				}) || []),
			],
		}),
		append: (state, { payload }) => ({ ...state, ...payload }),
		replaceQuestion: (state, { payload: { question, allowFindByIndex = false } }) => ({
			...(state || {}),
			questions: searchForNodeInTreeAndReplace({
				list: JSON.parse(JSON.stringify(state.questions, undefined, 2)),
				single: question,
				allowFindByIndex,
			}),
		}),
		replaceStatement: (state, { payload: { statement } }) => ({
			...(state || {}),
			statements: state?.statements?.map((item) =>
				item?.id?.toString() === statement?.id?.toString() ? statement : item
			),
		}),
		delete: () => initialState,
	},
});

export const proceduresSelector = (state) => state?.procedures || {};

export const { actions, reducer } = slice;

export default reducer;
